import React, { useState, useEffect } from "react";
import useStyles from "../styles/slider";
import clsx from "clsx";

interface SliderProps {
    children: React.ReactNode[];
    interval?: number;
}

const Slider: React.FC<SliderProps> = ({ children, interval = 3000 }) => {
    const classes = useStyles();
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === children.length - 1 ? 0 : prevIndex + 1
        );
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? children.length - 1 : prevIndex - 1
        );
    };

    const handleDotClick = (index: number) => {
        setCurrentIndex(index);
    };

    // Auto-derulare slide-uri la intervale regulate
    useEffect(() => {
        const sliderInterval = setInterval(() => {
            handleNext();
        }, interval);

        // Curățare interval la demontarea componentului
        return () => {
            clearInterval(sliderInterval);
        };
    }, [currentIndex, interval]);

    return (
        <div className={classes.sliderContainer} style={{ width: '100%', overflow: 'hidden', position: 'relative' }}>
            <div
                className={classes.sliderWrapper}
                style={{ 
                    transform: `translateX(-${currentIndex * 100}vw)`,
                    display: 'flex',
                    width: `${children.length * 100}vw`
                }}
            >
                {children.map((child, index) => (
                    <div 
                        key={index} 
                        className={classes.slide}
                        style={{ 
                            width: `100vw`,
                            flexShrink: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-start'
                        }}
                    >
                        {child}
                    </div>
                ))}
            </div>
            
            {/* Bulinele de navigare */}
            <div className={classes.dotsContainer}>
                {children.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => handleDotClick(index)}
                        className={clsx(classes.dot, currentIndex === index && classes.dotActive)}
                        aria-label={`Slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default Slider;